<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-title style="padding: 10px 0 0 10px; height: 30px;">
                        <v-col cols="12">
                            <span style="position: relative; top: -15px;">{{ $t('select-dates.title') }}</span>
                            <v-btn icon style="top: -20px; left: 10px; float: right;">
                                <v-icon @click="showDialog=false">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-card-title>
                    <v-card-subtitle style="padding: 0 22px 20px 22px;">
                        <span style="position: relative; top: 25px;">{{ $t('select-dates.subtitle') }}</span>
                    </v-card-subtitle>
                    <v-card-text style="padding: 5px;">
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialog1"
                                        v-model="modal1"
                                        :return-value.sync="initDate"
                                        persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="initDateFormatted"
                                                :rules="[validationRules.required]"
                                                :label="$t('select-dates.init-date')"
                                                prepend-icon="mdi-calendar"                                                
                                                readonly
                                                v-bind="attrs"
                                                v-on="on" 
                                                @blur="initDate = parseDate(initDateFormatted)">
                                                </v-text-field>
                                        </template>
                                        <v-date-picker 
                                            v-if="modal1"
                                            v-model="initDate"
                                            :first-day-of-week="1" 
                                            :locale="$i18n.locale"
                                            :min="calculateOneYearAgo()"
                                            :max="new Date().toISOString()"
                                            color="#C01033"
                                            scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn color="#c01033" text class="btn-link"  style="width: 100px;" @click="modal1=false">{{ $t('dialog.cancel') }}</v-btn>
                                            <v-btn class="wemob-btn primary" style="width: 100px;" @click="$refs.dialog1.save(initDate)">{{ $t('dialog.ok') }}</v-btn>                                            
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialog2"
                                        v-model="modal2"
                                        :return-value.sync="initTime"
                                        persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="initTime"
                                            :rules="[validationRules.required]"
                                            :label="$t('select-dates.init-time')"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-time-picker 
                                            v-if="modal2" 
                                            v-model="initTime" 
                                            ampm-in-title
                                            format="24hr"
                                            scrollable 
                                            color="#C01033"
                                            full-width>
                                            <v-spacer></v-spacer>
                                            <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="modal2=false">{{ $t('dialog.cancel') }}</v-btn>
                                            <v-btn class="wemob-btn primary" style="width: 100px;" @click="$refs.dialog2.save(initTime)">{{ $t('dialog.ok') }}</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialog3"
                                        v-model="modal3"
                                        :return-value.sync="endDate"
                                        persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="endDateFormatted"
                                                :rules="[validationRules.required]"
                                                :label="$t('select-dates.end-date')"
                                                prepend-icon="mdi-calendar"                                                
                                                readonly
                                                required
                                                v-bind="attrs"
                                                v-on="on" 
                                                @blur="endDate = parseDate(endDateFormatted)">
                                                </v-text-field>
                                        </template>
                                        <v-date-picker 
                                            v-if="modal3"
                                            v-model="endDate"
                                            :first-day-of-week="1" 
                                            :locale="$i18n.locale"
                                            :min="calculateOneYearAgo()"
                                            :max="new Date().toISOString()"
                                            color="#C01033"
                                            scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="modal3=false">{{ $t('dialog.cancel') }}</v-btn>
                                            <v-btn class="wemob-btn primary" style="width: 100px;" @click="$refs.dialog3.save(endDate)">{{ $t('dialog.ok') }}</v-btn>                                            
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialog4"
                                        v-model="modal4"
                                        :return-value.sync="endTime"
                                        persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endTime"
                                            :rules="[validationRules.required]"
                                            :label="$t('select-dates.end-time')"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-time-picker 
                                            v-if="modal4" 
                                            v-model="endTime" 
                                            ampm-in-title
                                            format="24hr"
                                            scrollable 
                                            color="#C01033"
                                            full-width>
                                            <v-spacer></v-spacer>
                                            <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="modal4=false">{{ $t('dialog.cancel') }}</v-btn>
                                            <v-btn class="wemob-btn primary" style="width: 100px;" @click="$refs.dialog4.save(endTime)">{{ $t('dialog.ok') }}</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row v-if="showError" style="margin-top: 0; margin-bottom: 0;">
                               <v-col cols="12">
                                 <v-alert type="error">
                                   {{ $t('select-dates.error') }}
                                 </v-alert>
                               </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#c01033" text class="btn-link" style="width: 100px;" @click="doCancel()">{{ $t('dialog.cancel') }}</v-btn>
                        <v-btn class="wemob-btn primary" style="width: 100px;" @click="doOk()">{{ $t('dialog.ok') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
    name: 'SelectDatesDialog',
    mixins: [ BaseModule ],
    data() {
        return { 
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            initDate: null,
            initDateFormatted: null,
            initTime: null,
            endDate: null,
            endDateFormatted: null,
            endTime: null,
            timestamp: {},
            showDialog: false,
            showError: false,
            msgCbOk: null,
            msgCbCancel: null,
        }
    },
    methods: {
        isVisible: function() {
            return this.showDialog;
        },
        close: function() {
            this.showDialog = false; 
        },
        open: function(msgCbOk, msgCbCancel) {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            var date = new Date();

            this.initDate = date.toISOString().substr(0, 10);
            this.initDateFormatted = this.formatDate(this.initDate);
            this.initTime = '00:00';
            this.endDate = date.toISOString().substr(0, 10);
            this.endDateFormatted = this.formatDate(this.endDate);
            this.endTime = this.parseTime(date.toLocaleTimeString());
            this.timestamp = {};
            this.showError = false;
            
            this.showDialog = true;
            this.msgCbOk = msgCbOk;
            this.msgCbCancel = msgCbCancel;
        },
        doOk: function() {
            if (!this.$refs.form.validate()) {
                return;
            }

            if (!this.checkDates()) {
                return;
            }

            this.showDialog = false;

            if (this.msgCbOk) {
                this.msgCbOk(this.timestamp);
            }
        },
				doCancel() {
            this.showDialog = false;

            if (this.msgCbCancel) {
                this.msgCbCancel();
            }
				},
        checkDates() { 
            var init = new Date(`${this.initDate}T${this.initTime}:00`).getTime();
            var end = new Date(`${this.endDate}T${this.endTime}:00`).getTime();

            this.showError = init > end;

            this.timestamp = { init: init, end: end };

            return !this.showError;
        },
        formatDate (date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');

            return `${day}/${month}/${year}`;
        },
        parseDate (date) {
            if (!date) return null;

            const [day, month, year] = date.split('/');

            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        parseTime (time) {
            if (!time) return null;

            // eslint-disable-next-line no-unused-vars
            const [hours, minutes, seconds] = time.split(':');

            return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
        },
        calculateOneYearAgo() {
            var d = new Date();
            d.setFullYear(d.getFullYear() - 1);

            return d.toISOString();
        }
    },
    watch: {
        initDate () {
            this.initDateFormatted = this.formatDate(this.initDate);
        },
        endDate () {
            this.endDateFormatted = this.formatDate(this.endDate);
        },
    },
  }
</script>